import noop from 'lodash/noop';
import { defaultLocale } from '@atlassian/jira-common-constants/src/supported-locales.tsx';
import { SET, type SetAction } from './actions.tsx';
import type { Context } from './types.tsx';

export type ContextState = Context;

type Action = SetAction;

export const initialState: ContextState = Object.freeze({
	baseUrl: '',
	isAdmin: false,
	locale: defaultLocale,
	onQueryChanged: noop,
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: ContextState = initialState, action: Action): ContextState => {
	switch (action.type) {
		case SET: {
			return Object.freeze(action.payload);
		}
		default:
			return state;
	}
};
